// extracted by mini-css-extract-plugin
export default {"button":"LYWIsvVA","content":"H41MxQx6","letterSpacing":"_893msfx"};